import { Component } from 'react';

import logError from 'utils/rollbar';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    this.setState((state) => ({ ...state, hasError: true }));
    logError(error, info);
  }

  render() {
    const { props, state } = this;
    if (!state.hasError) {
      return props.children;
    }
    return (
      <div>
        <h1>Sorry there was an error</h1>
        <p>
          Okay that wasn&apos;t great, something is definitely broken - this is
          the hard error page
        </p>
      </div>
    );
  }
}

export default AppErrorBoundary;
